var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container",staticStyle:{"min-height":"100vh"}},[(_vm.uploads && _vm.ready)?_c('ux-image-grid-view-a',{attrs:{"sections":true,"items":_vm.uploads,"keyTitle":"name"}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }